import { IPhotoGallery } from 'redhotpie-shared-lib/interfaces/IUser';
import * as utils from '../functions/utils';

export default class PhotoGallery {
  imageCount: number;
  galleryID: number;
  galleryId: number;
  isPublic: boolean;
  name: string;
  hasAccess: boolean;
  status: string;
  expiredTime: string;

  constructor() {
    this.imageCount = 0;
    this.galleryID = 0;
    this.galleryId = 0;
    this.isPublic = false;
    this.name = '';
    this.hasAccess = false;
    this.status = '';
    this.expiredTime = '';
  }

  static mappingObject(_gallery: any): IPhotoGallery {
    let photoGallery = Object.assign(new PhotoGallery(), _gallery);
    photoGallery.imageCount = _gallery.ImageCount;
    photoGallery.galleryID = _gallery.GalleryID;
    photoGallery.galleryId = _gallery.GalleryID;
    photoGallery.isPublic = _gallery.IsPublic;
    photoGallery.name = _gallery.Name;
    photoGallery.hasAccess = _gallery.HasAccess;
    photoGallery.status = _gallery.Status;
    photoGallery.expiredTime = _gallery.ExpiryDateUTC;
    photoGallery = utils.cleanObjectKeys(Object.keys(new PhotoGallery()), photoGallery);
    return photoGallery;
  }

  static mappingObjects(_listGallery: any[]): IPhotoGallery[] {
    const galleries: IPhotoGallery[] = [];
    _listGallery.forEach(_gallery => {
      galleries.push(PhotoGallery.mappingObject(_gallery));
    });
    return galleries;
  }
}
